import React from 'react';
import { cancelButton, save, Text } from '../../app-components';
import { ROUTES } from '../../Lib/constants';
import AdminData from './AdminData';
import AddAdmin from './AddAdmin';
import EditAdmin from './EditAdmin';
import vars from '../../theme/vars';
import FtsSearch from '../../Components/TableFilters/FtsSearch';
import { addIcon, passwordIcon } from '../../images';
import { IconButton } from '../../app-components/buttons/Buttons';

const { headings } = vars;

export default {
  [ROUTES.adminData.name]: {
    screen: AdminData,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Manage Admins</Text>,
    headerActions: [
      (props) => (
        <FtsSearch
          {...props}
          action={{
            exp: ['username', 'phonenumber', 'email', 'status'],
          }}
        />
      ),
      {
        render: () => (
          <IconButton
            description="Add Admin"
            tooltipId="add-admin"
            icon={addIcon}
            label="Add Admin"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: () => ({
          view: ROUTES.addAdmin.name,
          push: true,
          expanded: true,
        }),
      },
    ],
  },
  [ROUTES.addAdmin.name]: {
    screen: AddAdmin,
    expanded: true,
    title: () => <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>Add Admin</Text>,
    headerActions: [cancelButton, save],
  },
  [ROUTES.editAdmin.name]: {
    screen: EditAdmin,
    expanded: true,
    title: ({ navigation }) => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>
        Edit
        {' '}
        {navigation.state.params.item.username}
      </Text>
    ),
    headerActions: [cancelButton, save],
  },

  [ROUTES.ViewAdmin.name]: {
    screen: EditAdmin,
    screenProps: {
      editable: true,
      type: 'standard',
      visible: false,
      fromView: true,
    },
    expanded: true,
    title: ({ navigation }) => (
      <Text style={{ ...headings.pageHeading, marginLeft: 12 }}>
        {navigation.state.params.item.username}
        {' '}
        Details
      </Text>
    ),
    headerActions: [
      cancelButton,
      {
        render: () => (
          <IconButton
            description="Change Password"
            tooltipId="daler-password-change"
            icon={passwordIcon}
            label="Change Password"
            labelStyle={{
              fontSize: 18,
              color: '#ffffff',
              fontFamily: 'Mulish-SemiBold',
            }}
          />
        ),
        type: 'link',
        link: (props) => ({
          view: ROUTES.password.name,
          params: {
            ...props?.navigation?.state?.params,
            type: 'admin',
          },
          modal: true,
          modalProps: {
            backgroundColor: 'transparent',
          },
        }),
      },
      save,
    ],
  },
};
